<template>
	<div class="">
		<div class="">
			<h3><small>Search by company name</small></h3>
			<v-select :options="company" v-model="company_result" v-on:change="byCompany">
		      <option disabled selected value="">Select one</option>
		    </v-select>
			<hr>
			<h3><small>Or make your own rankings below</small></h3>
			<table  class="table" v-if="advanced">
				<thead>
					<tr>
						<th><h4><small>How important are the following to you:</small></h4></th>
						<th class="text-center"><small>Least<br>important</small><br>1</th>
						<th class="text-center">2</th>
						<th class="text-center">3</th>
						<th class="text-center">4</th>
						<th class="text-center"><small>Most<br>important</small><br>5</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th>Welcoming culture for military</th>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="1" /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="2"  /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="3"  /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="4"  /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="5"  /></td>
					</tr>
					<tr>
						<th>Military/veteran recruiting</th>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting" class="form-control" value="1" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="2" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="3" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="4" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="5" ></td>
					</tr>
					<tr>
						<th>Military/veteran policies</th>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies" class="form-control" value="1" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="2" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="3" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="4" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="5" ></td>
					</tr>
					<tr>
						<th>Reservist/National Guard policies</th>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="1" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="2" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="3" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="4" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="5" ></td>
					</tr>
					<tr>
						<td colspan="6" class="text-left">

							<div class="row">
								<div class="col col-lg-3">
									<label>Industry
										<v-select  :options="industry" v-model="importantFilter.industry">
									      <option disabled value="0">Select one</option>
									    </v-select>
									</label>
								</div>
								<div class="col col-lg-3">
									<label>State
										<v-select  :options="states" v-model="importantFilter.state">
									      <option disabled value="0">Select one</option>
									    </v-select>
									</label>
								</div>
								<div class="col col-lg-3">
									<label>Company size
										<select class="form-control" v-model="importantFilter.company_size">
											<option value="">Any size</option>
											<option value="1">0-100 employees</option>
											<option value="2">101-10,000 employees</option>
											<option value="3">10,001-30,000 employees</option>
											<option value="4">More than 30,000 employees</option>
										</select>
									</label>
								</div>
								<div class="col col-lg-3">
									<label>% veteran employees
										<select class="form-control" v-model="importantFilter.veteran_employee_percentage">
											<option value="">Any proportion</option>
											<option value="2">At least 2.5%</option>
											<option value="5">At least 5%</option>
											<option value="10">At least 10%</option>
											<option value="20">At least 20%</option>
										</select>
									</label>
								</div>
							</div>	
						</td>
					</tr>
					<tr class="text-left">
						<td colspan="6">
							<div class="row">
								<div class="col col-lg-12">
									<div class="checkbox">
									    <label>
									      <input type="checkbox" name="resource_group"  v-model="importantFilter.resource_group"> <strong>Military/veteran employee resource group</strong>
									    </label>
									</div>
									<div class="checkbox">
									    <strong><u>Military spouse work flexibility</u></strong>
									      <br><label><input type="checkbox" name="can_remotely"  v-model="importantFilter.can_remotely"> Can work remotely</label>
									      <br><label><input type="checkbox" name="can_utilize"  v-model="importantFilter.can_utilize"> Can utilize flexible scheduling options</label>
									      <br><label><input type="checkbox" name="can_transfer" v-model="importantFilter.can_transfer"> Can transfer to a different location</label>
									</div>
								</div>
		
							</div>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td colspan="5"><button class="btn btn-info" v-on:click="byFilter">SEARCH</button></td>
					</tr>
				</tfoot>
			</table>
		</div>		
	</div>
</template>
<script>
	export default {
		props: ['industry', 'company'],
		data: function(){
			return {
				company_result: null,
				advanced: true,
				contents: null,
				importantFilter: {
					industry: null,
					state: null,
					company_size: null,
					veteran_employee_percentage: null,
					can_remotely: false,
					can_utilize: false,
					can_transfer: false,
					resource_group: false,
					welcoming_culture_for_military: null,
					military_veteran_recruiting: null,
					military_veteran_policies: null,
					reservist_national_guard_policies: null
				}
			}
		},
		methods: {
			advancedSearch: function()
			{
				if(this.advanced){
					this.advanced = false; 
					return;
				}
				this.advanced = true
			},
			byCompany: function()
			{
				console.log(this.company_result);
			},
			byFilter: function()
			{
				// let self = this;
				// axios.post('/api/filter', self.importantFilter)
				// .then(function(response){
				// 	self.contents = response.data;
				// })
				// .catch(function(error){
				// 	console.log('error', error)
				// });
				if(this.importantFilter.industry && this.importantFilter.industry.value)
					this.importantFilter.industry = this.importantFilter.industry.value;
				if(this.importantFilter.state && this.importantFilter.state.value)
					this.importantFilter.state = this.importantFilter.state.value;

				var recursiveEncoded = $.param( this.importantFilter );
				window.location = '/results?'+recursiveEncoded;
			}
		},
		watch: {
			company_result: function(oldval, newval){
				window.location = '/company/' + this.company_result.value;
			},
			importantFilter: function()
			{
				this.company_result = null;
			}
		}
	}
</script>